<template>
<div>
    <section class="section hero">
        <div class="container">
          <h1 class="title big-title has-text-centered">
            ການແຂ່ງຂັນກິລາເຕະບານ ຊີງຂັນສະຫາຍເລຂາຄະນະບໍລິຫານງານ ສູນກາງຊາວໝຸ່ມປະຊາຊົນປະຕິວັດລາວ <br /> ປະຈຳປີ 2024
          </h1>
            <div class="up-comming has-text-centered">
                <h1 class="title up-cover-title">Matched</h1>
            </div>
            <h1 class="title main-title up-main has-text-centered">
                ຜົນການແຂ່ງຂັນທີ່ຜ່ານມາ
            </h1>
            <!--
            <div>
                <h1 class="sub-m-title">
                    <span class="deactive-title">11 ກັນຍາ 2020</span>
                    <span>11 ກັນຍາ 2020</span><span class="deactive-title">11 ກັນຍາ 2020</span>
                </h1>
            </div>
-->
            <div class="columns is-multiline">
                <div class="column is-6" v-for="(match_finished, index) in matched" :key="index">
                    <div class="card match" @click="match_detail(match_finished.id)">
                        <div class="card-content">
                            <div class="imso_mh__ma-sc-cont">
                                <div class="imso_mh__l-tm-sc imso_mh__scr-it imso-light-font">
                                    <img :src="match_finished.team1_logo" alt="" width="40" height="40" />
                                </div>
                                <div class="imso_mh__scr-it imso_mh__sep imso-light-font">
                                    {{ match_finished.team_1 }}
                                </div>
                                <div class="imso_mh__r-tm-sc imso_mh__scr-it imso-light-font">
                                    <span class="score">{{ match_finished.team_1_score }}</span>
                                    <div class="active-score" v-if="
                        match_finished.team_1_score >
                        match_finished.team_2_score
                      "></div>
                                </div>
                            </div>
                            <div class="imso_mh__ma-sc-cont">
                                <div class="imso_mh__l-tm-sc imso_mh__scr-it imso-light-font">
                                    <img :src="match_finished.team2_logo" alt="" width="40" height="40" />
                                </div>
                                <div class="imso_mh__scr-it imso_mh__sep imso-light-font">
                                    {{ match_finished.team_2 }}
                                </div>
                                <div class="imso_mh__r-tm-sc imso_mh__scr-it imso-light-font">
                                    <span class="score">{{ match_finished.team_2_score }}</span>
                                    <div class="active-score" v-if="
                        match_finished.team_2_score >
                        match_finished.team_1_score
                      "></div>
                                </div>
                            </div>
                            <span class="s-date">Date - {{ match_finished.match_date }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section" v-if="top_score.length">
        <div class="container">
            <h1 class="sub-m-title">ສະຫຼຸບຜູ້ຍິງປະຕູຫຼາຍສຸດຕະຫຼອດການແຂ່ງຂັນ</h1>
            <div class="columns is-multiline">
                <div class="column is-6-desktop is-12-mobile">
                    <div class="card static-player">
                        <div class="card-header">
                            <div class="card-content">
                                <div class="card-title">
                                    <h1>ຜູ້ຍິງປະຕູຫຼາຍສຸດ</h1>
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="imso_mh__ma-sc-cont-player" v-for="(top_scorer, index) in top_score" :key="index">
                                <div class="imso_mh__l-tm-sc imso_mh__scr-it imso_mh__l-tm-sc-player imso-light-font">
                                    <div class="user-profile-top-score has-right">
                                        <img :src="top_scorer.logo" alt="" />
                                    </div>
                                </div>
                                <div class="imso_mh__scr-it imso_mh__sep imso-light-font top-score">
                                    {{ top_scorer.name }} {{ top_scorer.sur_name }}
                                </div>
                                <div class="imso_mh__scr-it imso_mh__sep imso-light-font top-score">
                                  {{ top_scorer.initial_name }}
                                </div>
                                <div class="imso_mh__r-tm-sc imso_mh__scr-it imso-light-font top-score">
                                    <span class="score">{{ top_scorer.goal_score }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column is-6-desktop is-12-mobile">
                    <div class="card static-player">
                        <div class="card-header">
                            <div class="card-content">
                                <div class="card-title">
                                    <h1>ຜູ້ຊ່ວຍໃຫ້ຍິງປະຕູຫຼາຍສຸດ</h1>
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="imso_mh__ma-sc-cont-player" v-for="(assist, index) in top_assist" :key="index">
                                <div class="imso_mh__l-tm-sc imso_mh__scr-it imso_mh__l-tm-sc-player imso-light-font">
                                    <div class="user-profile-top-score has-right">
                                        <img :src="assist.logo" alt="" />
                                    </div>
                                </div>
                                <div class="imso_mh__scr-it imso_mh__sep imso-light-font top-score">
                                    {{ assist.name }} {{ assist.sur_name }}
                                </div>
                                <div class="imso_mh__scr-it imso_mh__sep imso-light-font top-score">
                                  {{ assist.initial_name }}
                                </div>
                                <div class="imso_mh__r-tm-sc imso_mh__scr-it imso-light-font top-score">
                                    <span class="score">{{ assist.assist_score }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          <div class="card future">
            <div class="card-content">
              <div class="columns is-mobile">
                <div class="column is-4 future-area">
                  <h1 class="u-title">{{ card_info.goals }}</h1>
                  <p class="sub">ປະຕູ</p>
                </div>
                <div class="column is-4 future-area">
                  <h1 class="u-title">{{ card_info.yellow }}</h1>
                  <p class="yellow-card"></p>
                </div>
                <div class="column is-4 future-area">
                  <h1 class="u-title">{{ card_info.red }}</h1>
                  <p class="red-card"></p>
                </div>
              </div>
            </div>
          </div>

        </div>
    </section>
</div>
</template>

<script>
import match from "@/mixins/match";
export default {
    name: "Match",
    mixins: [match],
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.section.myhero {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
}

.section {
    padding-bottom: 2rem;
    padding-bottom: 3rem;
}

.card {
    &.match {
        .card-content {
            padding-right: 0px;
        }
    }

    &.future {
        background-color: #f8f8f8;
        border-radius: 4px;
    }
}

.future-area {
    text-align: center;
}

.card-parent-top {
    width: 100%;
    display: flex;
    text-align: center;
}

.card-parent-bottom {
    width: 100%;
    display: flex;
    text-align: center;
}

.card-content .col-one {
    width: 30%;
}

.card-content .col-two {
    width: 40%;
    margin-top: auto;
    margin-bottom: auto;
}

.col-two .box-vs {
    background-color: #08037c;
    color: #fff;
    margin: 0px 6px;
    padding: 2px 0px;
    border-radius: 4px;
}

.card-content .col-three {
    width: 30%;
}

.col-bottom-one {
    width: 50%;
    text-align: left;
}

.col-bottom-two {
    width: 50%;
    text-align: right;
}

.card-parent-footer {
    width: 100%;
    display: flex;
    text-align: center;
    padding: 8px 4px;
}

.col-footer-two {
    width: 50%;
    text-align: center;
}

.col-footer-one {
    width: 50%;
    text-align: center;
}

progress.progress {
    margin-bottom: 1rem;
    color: $primary-color;
    height: 10px;

    .is-red {
        color: $primary-color;
    }
}

.progress.is-red::-webkit-progress-value {
    color: $primary-color;
    height: 10px;
    background-color: rgba($primary-color, 1);
}

.progress.is-red::-moz-progress-bar {
    color: $primary-color;
    height: 10px;
    background-color: rgba($primary-color, 1);
}

.progress.is-red::-ms-fill {
    color: $primary-color;
    height: 10px;
    background-color: rgba($primary-color, 1);
}

.progress.is-red:indeterminate {
    color: $primary-color;
    height: 10px;
    background-color: rgba($primary-color, 1);
}

.m-sub {
    font-size: 20px;
    color: #4a4a4a;
}

.sub-m-title {
    margin-bottom: 10px;
    font-size: 18px;
    color: #000;
    font-weight: 600;
}

.card-title {
    color: #000000;
}

.card.static-player .card-content {
    padding-left: 10px;
    padding-right: 10px;
}

.red-card,
.yellow-card {
    margin-right: auto;
    margin-left: auto;
}

@media (max-width: 520px) {
  .top-score{
font-size: 14px;
  }
}
</style>
